import {getSentry} from "./getSentry";

export const captureMessageWrapper = (message: any) => {
    if (import.meta.env.VITE_APP_ENV === 'development') {
        console.error(message);
    } else {
        getSentry().then(sentryAsync => {
            sentryAsync.captureMessage(message);
        })
    }
}